import { useTranslation } from 'react-i18next';

export default function ESG() {
  const { t } = useTranslation();

  const esgItems = [
    { code: 'E', icon: 'ri-leaf-line', color: 'bg-green-500', categoryKey: 'esg_cat0', itemKeys: ['esg_item0_0', 'esg_item0_1', 'esg_item0_2'] },
    { code: 'S', icon: 'ri-heart-line', color: 'bg-orange-500', categoryKey: 'esg_cat1', itemKeys: ['esg_item1_0', 'esg_item1_1'] },
    { code: 'G', icon: 'ri-shield-check-line', color: 'bg-teal-500', categoryKey: 'esg_cat2', itemKeys: ['esg_item2_0'] },
  ];

  return (
    <section id="esg" className="pb-16 md:pb-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Hero banner */}
        <div className="mb-12 md:mb-20 relative rounded-lg overflow-hidden">
          <img
            src="https://static.readdy.ai/image/17b7b4fe0c11dd66d6ca2f4f9437a472/560c594128402d59bce18f54cd3f9973.jpeg"
            alt="ESG Commitment"
            className="w-full h-52 md:h-96 object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-8">
            <p
              className="text-teal-400 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.2em' }}
            >
              {t('esg_tagline')}
            </p>
            <h2
              className="text-xl md:text-4xl lg:text-5xl font-bold text-white leading-tight whitespace-pre-line"
              style={{ fontFamily: 'Noto Sans KR, sans-serif', wordBreak: 'keep-all' }}
            >
              {t('esg_title')}
            </h2>
            <div className="w-10 md:w-12 h-1 bg-teal-400 mx-auto mt-4 md:mt-6"></div>
          </div>
        </div>

        {/* ESG Cards */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-8">
          {esgItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 md:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
                <div className={`w-12 h-12 md:w-16 md:h-16 flex items-center justify-center ${item.color} rounded-full flex-shrink-0`}>
                  <i className={`${item.icon} text-2xl md:text-3xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-2xl font-bold text-gray-900" style={{ fontFamily: 'Noto Sans KR, sans-serif' }}>
                    {t(item.categoryKey)}
                  </h3>
                  <p className="text-sm md:text-lg text-gray-500" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    ({item.code})
                  </p>
                </div>
              </div>
              <div className="space-y-3 md:space-y-4">
                {item.itemKeys.map((itemKey, subIndex) => (
                  <div key={subIndex} className="flex items-start gap-3">
                    <span className="text-teal-500 text-base md:text-xl font-bold flex-shrink-0">√</span>
                    <p className="text-sm md:text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Noto Sans KR, sans-serif' }}>
                      {t(itemKey)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
